import {GET_BRAND} from "../../redux/types";

export default function reducer(state = {
    name: '',
    domain: '',
    id: '',
    theme: '',
    favicon: '',
    support: '',
    fetching: true
}, action) {
    switch (action.type) {
        case GET_BRAND :
            return {...state, ...action.payload.data, fetching: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/brand/BrandReducer.js